import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { ClientModel, IClientDTO } from "../models/client/client";
import service from "@/services/api.service";
import { ClientGridViewModel } from "../models/client/clientGridView";
import { IClientContactDTO } from "../models/client/clientContact";
import { IClientKeyContactDTO } from "../models/client/clientKeyContact";
import { IClientRiskDTO } from "../models/client/clientRisk";
import { IClientOpportunityDTO } from "../models/client/clientOpportunity";
import PMOTeam from "../models/client/pmoTeam";
import { GuidItemModel } from "../models/shared/guidItem";
import { StateListsModel } from "../models/shared/stateLists";
import { ClientDetailedViewModel } from "../models/client/clientDetailedView";
import { PMOTeamGridViewModel } from "../models/client/pmoTeamGridView";
import { IEligibleClientManagerResponse } from "../models/client/response/eligibleClientManagerResponse";
import PMOTeamMember, { IPMOTeamMemberDTO } from "../models/client/pmoTeamMember";
import { IPMOTeamDetailedViewDTO } from "../models/client/pmoTeamDetailedView";
import PMOTeamLead from "../models/client/pmoTeamLead";
import { IPMOProjectDTO } from "../models/project/PMOProject";
import { IPMOTeamApexProjectGridViewDTO, PMOTeamApexProjectGridViewModel } from "../models/client/pmoTeamApexProjectGridView";
import { ClientSearchDataModel, IClientSearchDataListingDTO } from "../models/client/clientSearchListingDTO";
import _ from "lodash";
import { ClientTeamDeactivationReasonModel } from "../models/client/clientTeamDeactivationReason";
import { ClientDeactivationReasonModel } from "../models/client/clientDeactivationReasonDTO";
import { ITeamOperationsResponse } from "../models/client/response/teamOperationsResponse";
import { ITeamCorrespondenceSaveDTO } from "../models/client/teamCorrespondence";
import { ITeamCorrespondenceResponse } from "../models/client/response/teamCorrespondenceResponse";
let ClientModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56;
    let ClientModule = class ClientModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.client = null;
            this.mediaFileId = "";
            this.imageUrl = "";
            this.clients = [];
            this.clientContacts = [];
            this.teams = [];
            this.team = null;
            this.teamsGridView = [];
            this.eligableTeamMember = [];
            this.eligibleCSMs = [];
            this.eligibleTSMs = [];
            this.clientRisks = [];
            this.riskLevels = [];
            this.clientOpportunities = [];
            this.clientAssignedEmployees = [];
            // The latest Operations tab response (its shared details) and every loaded tab's section by key
            this.teamOperations = null;
            this.teamOperationSections = {};
            this.teamOperationHistory = null;
            this.teamCorrespondence = null;
            this.clientId = "";
            this.clientDetailedView = null;
            this.includeInactiveContacts = false;
            this.countryLists = [];
            this.stateLists = [];
            this.apiNode = "PMOClient";
            this.searchParams = null;
        }
        async GetClients(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/clients`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetClients(plainToClass(ClientGridViewModel, data.clients));
                this.SetCountryList(plainToClass(GuidItemModel, data.countryLists));
                this.SetStateLists(plainToClass(StateListsModel, data.stateLists));
            }
            return data;
        }
        // Client Health grid; the page keeps the rows itself, so nothing is stored here
        async GetClientHealth(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/client-health`;
            let { data } = await service.post(url, searchData);
            return data;
        }
        async SetClients(clients) {
            this.clients = clients;
        }
        async SetCountryList(countryLists) {
            this.countryLists = countryLists;
        }
        async SetStateLists(stateLists) {
            this.stateLists = stateLists;
        }
        async GetCountryStateLists() {
            var url = `${getTenantId()}/${this.apiNode}/country-state-lists`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCountryList(plainToClass(GuidItemModel, data.countryLists));
                this.SetStateLists(plainToClass(StateListsModel, data.stateLists));
            }
            return data;
        }
        async SaveClient(client) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, client);
            if (data) {
                this.SetClientId(data.client);
            }
            return data;
        }
        async SetClientId(client) {
            this.clientId = client.id.toString();
        }
        async EditClient(client) {
            var url = `${getTenantId()}/${this.apiNode}` + "/edit-client";
            let { data } = await service.post(url, client);
            if (data) {
                this.SetClientDetails(plainToClass(ClientDetailedViewModel, data.clientDetailedView));
                return data;
            }
        }
        //Delete
        async DeleteClientById(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/delete-client";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetClientDetailById(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/Get-client";
            let { data } = await service.get(url);
            if (data) {
                this.SetClientDetails(plainToClass(ClientDetailedViewModel, data.clientDetailedView));
            }
            return data;
        }
        async GetClientContacts(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/get-client-contacts?includeInactiveContacts=" + this.includeInactiveContacts;
            let { data } = await service.get(url);
            if (data) {
                this.SetClientContacts(data.clientContacts);
            }
            return data;
        }
        async SetClientContacts(clientContacts) {
            this.clientContacts = clientContacts;
        }
        // Shows a just-added contact straight away (server order: Primary Contacts, then Appraisal Reviewers, then the rest,
        // by first name then last name); the machine re-fetches the list in the background to fill in image and address names.
        async AddClientContactToList(contact) {
            const byName = (a, b) => (a || "").localeCompare(b || "", undefined, { sensitivity: "base" });
            const byFlag = (a, b) => (b ? 1 : 0) - (a ? 1 : 0);
            this.clientContacts = [...this.clientContacts.filter((x) => x.id != contact.id), contact].sort((a, b) => byFlag(a.isKeyContact, b.isKeyContact) || byFlag(a.isReviewer, b.isReviewer) || byName(a.firstName, b.firstName) || byName(a.lastName, b.lastName));
        }
        async SetClientDetails(clientDetailedView) {
            this.clientDetailedView = clientDetailedView;
        }
        async SetIncludeInactiveContacts(includeInactiveContacts) {
            this.includeInactiveContacts = includeInactiveContacts;
        }
        async SaveClientContact(clientContact) {
            var url = `${getTenantId()}/${this.apiNode}` + "/client-contact";
            let { data } = await service.post(url, clientContact);
            if (data) {
                if (data.clientContact && data.clientContact.isKeyContact) {
                    await this.SetKeyContact({
                        clientId: data.clientContact.clientId.toString(),
                        contactId: data.clientContact.id.toString(),
                        isKeyContact: true,
                    });
                }
                return data;
            }
        }
        async EditClientContact(clientContact) {
            var url = `${getTenantId()}/${this.apiNode}` + "/edit-client-contact";
            let { data } = await service.post(url, clientContact);
            if (data) {
                return data;
            }
        }
        //Delete
        async DeleteClientContactById(contactId) {
            var url = `${getTenantId()}/${this.apiNode}/` + contactId + "/delete-contact";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async SetKeyContact(payload) {
            var url = `${getTenantId()}/${this.apiNode}` + "/set-key-contact";
            let { data } = await service.post(url, payload);
            if (data) {
                this.SetKeyContactOnClient(payload);
                return data;
            }
        }
        async SetKeyContactOnClient(payload) {
            var that = this;
            if (!that.clientContacts) {
                return;
            }
            // A client can have several Primary Contacts, so the others keep their flag
            var tar = that.clientContacts.findIndex((x) => x.id.toString() == payload.contactId);
            if (tar !== -1) {
                that.clientContacts[tar].isKeyContact = payload.isKeyContact;
            }
            that.clientContacts = [...that.clientContacts];
        }
        async UploadClientPicture(payload) {
            var url = `${getTenantId()}/${this.apiNode}/image/` + payload.type;
            let { data } = await service.post(url, payload.file);
            if (data) {
                this.SetMediaFileId(data.mediaFileId);
                this.SetMediaUrl(data.imageUrl);
                return data;
            }
        }
        async SetMediaFileId(mediaFileId) {
            this.mediaFileId = mediaFileId;
        }
        async SetMediaUrl(imageUrl) {
            this.imageUrl = imageUrl;
        }
        async ClearMediaFileData() {
            this.mediaFileId = "";
            this.imageUrl = "";
        }
        async GetTeams(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/get-teams";
            let { data } = await service.get(url);
            if (data) {
                this.SetTeams(plainToClass(PMOTeamGridViewModel, data.teams));
            }
            return data;
        }
        async SetTeams(teams) {
            this.teamsGridView = teams;
        }
        // Risk levels (PMORisks) change only by DbUp script, so they're loaded once and reused
        async GetRiskLevels() {
            if (this.riskLevels.length) {
                return this.riskLevels;
            }
            var url = `${getTenantId()}/${this.apiNode}/risk-levels`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRiskLevels(data.riskLevels ?? []);
            }
            return this.riskLevels;
        }
        async SetRiskLevels(riskLevels) {
            this.riskLevels = riskLevels;
        }
        async GetClientRisks(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/get-client-risks";
            let { data } = await service.get(url);
            if (data) {
                this.SetClientRisks(data.risks);
            }
            return data;
        }
        async SetClientRisks(risks) {
            this.clientRisks = risks;
        }
        async AddClientRisk(risk) {
            var url = `${getTenantId()}/${this.apiNode}` + "/client-risk";
            let { data } = await service.post(url, risk);
            if (data) {
                return data;
            }
        }
        async EditClientRisk(risk) {
            var url = `${getTenantId()}/${this.apiNode}` + "/edit-client-risk";
            let { data } = await service.post(url, risk);
            if (data) {
                return data;
            }
        }
        async DeleteClientRiskById(riskId) {
            var url = `${getTenantId()}/${this.apiNode}/` + riskId + "/delete-client-risk";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetClientOpportunities(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/get-client-opportunities";
            let { data } = await service.get(url);
            if (data) {
                this.SetClientOpportunities(data.opportunities);
            }
            return data;
        }
        async SetClientOpportunities(opportunities) {
            this.clientOpportunities = opportunities;
        }
        async AddClientOpportunity(opportunity) {
            var url = `${getTenantId()}/${this.apiNode}` + "/client-opportunity";
            let { data } = await service.post(url, opportunity);
            if (data) {
                return data;
            }
        }
        async EditClientOpportunity(opportunity) {
            var url = `${getTenantId()}/${this.apiNode}` + "/edit-client-opportunity";
            let { data } = await service.post(url, opportunity);
            if (data) {
                return data;
            }
        }
        async DeleteClientOpportunityById(opportunityId) {
            var url = `${getTenantId()}/${this.apiNode}/` + opportunityId + "/delete-client-opportunity";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetClientAssignedEmployees(clientId) {
            var url = `${getTenantId()}/${this.apiNode}/` + clientId + "/get-client-assigned-employees";
            let { data } = await service.get(url);
            if (data) {
                this.SetClientAssignedEmployees(data.assignedEmployees);
            }
            return data;
        }
        async SetClientAssignedEmployees(assignedEmployees) {
            this.clientAssignedEmployees = assignedEmployees;
        }
        async SaveTeam(team) {
            var url = `${getTenantId()}/${this.apiNode}` + "/team";
            let { data } = await service.post(url, team);
            if (data) {
                return data;
            }
        }
        async EditTeam(team) {
            var url = `${getTenantId()}/${this.apiNode}` + "/team";
            let { data } = await service.post(url, team);
            if (data) {
                return data;
            }
        }
        //Delete
        async DeleteTeamById(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId + "/delete-team";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async GetTeamDetailById(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId + "/get-team-detail";
            let { data } = await service.get(url);
            if (data) {
                this.SetTeamDetail(data.team);
                return data;
            }
        }
        async SetTeamDetail(team) {
            this.team = team;
        }
        // Team Operations (team detail > Operations)
        // One Operations tab (section); the shared details come with every tab
        async GetTeamOperations(payload) {
            var url = `${getTenantId()}/${this.apiNode}/` + payload.teamId + "/get-team-operations/" + payload.section;
            let { data } = await service.get(url);
            if (data) {
                this.SetTeamOperations(data);
            }
            return data;
        }
        async GetTeamOperationFieldHistory(payload) {
            // One request per field. Tools rows have no attribute, so it is left off the query.
            const histories = await Promise.all(payload.attributeIds.map(async (attributeId) => {
                const query = attributeId ? `?attributeId=${attributeId}` : "";
                const url = `${getTenantId()}/${this.apiNode}/` + payload.teamId + "/get-team-operation-history/" + payload.itemId + query;
                const { data } = await service.get(url);
                return data;
            }));
            const recorded = histories.filter((history) => !!history);
            this.SetTeamOperationHistory(recorded);
            return recorded;
        }
        async SaveTeamOperations(payload) {
            var url = `${getTenantId()}/${this.apiNode}/save-team-operations/` + payload.section;
            let { data } = await service.post(url, payload.dto);
            return data;
        }
        // Keeps the shared details of the latest tab and each loaded tab's section by key
        SetTeamOperations(response) {
            this.teamOperations = response;
            this.teamOperationSections = { ...this.teamOperationSections, [response.section.key]: response.section };
        }
        SetTeamOperationHistory(history) {
            this.teamOperationHistory = history;
        }
        // Start clean - a late response from a previously opened team may have written to the store
        ResetTeamOperations() {
            this.teamOperations = null;
            this.teamOperationSections = {};
            this.teamOperationHistory = null;
        }
        // Team Correspondence (team detail > Correspondence)
        async GetTeamCorrespondence(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamId + "/get-team-correspondence";
            let { data } = await service.get(url);
            if (data) {
                this.SetTeamCorrespondence(data);
            }
            return data;
        }
        // Every changed member x contact cell in one save
        async SaveTeamCorrespondence(dto) {
            var url = `${getTenantId()}/${this.apiNode}/save-team-correspondence`;
            let { data } = await service.post(url, dto);
            return data;
        }
        // null resets it, so a late response from a previously opened team isn't shown
        SetTeamCorrespondence(response) {
            this.teamCorrespondence = response;
        }
        // Shows a just-added member straight away (server order: current before ended, then by name);
        // the machine re-fetches the team in the background to fill in email and photo.
        async AddTeamMemberToList(member) {
            if (!this.team) {
                return;
            }
            const row = {
                id: member.id,
                employeeId: member.employeeId,
                employeeName: member.employeeName,
                employeeEmailId: null,
                employeeImageURL: null,
                startDate: member.startDate,
                startDateAsString: member.startDateAsString,
                endDate: member.endDate,
                endDateAsString: member.endDateAsString,
                dateOfJoinAsString: member.dateOfJoinAsString,
                clientProvidedEmail: member.clientProvidedEmail,
                engagementComments: member.engagementComments,
                isTeamLead: false,
                isActiveUser: member.isActiveUser,
                hasTeamLeadPrivilege: member.isEnded,
                isEnded: member.isEnded,
            };
            const members = [...this.team.teamMembers.filter((x) => x.employeeId != member.employeeId), row];
            members.sort((a, b) => Number(a.isEnded) - Number(b.isEnded) || (a.employeeName || "").localeCompare(b.employeeName || "", undefined, { sensitivity: "base" }));
            this.team = { ...this.team, teamMembers: members };
        }
        async GetEligableUserForTeam(teamId) {
            var url = `${getTenantId()}/${this.apiNode}` + "/get-eligable-users-for-team/" + teamId;
            let { data } = await service.get(url);
            if (data) {
                this.SetEligableUserForTeam(data.eligableTeamMember);
                return data;
            }
        }
        async SetEligableUserForTeam(eligableTeamMember) {
            this.eligableTeamMember = eligableTeamMember;
        }
        async GetEligibleClientManagers() {
            var url = `${getTenantId()}/${this.apiNode}` + "/get-eligible-client-managers";
            let { data } = await service.get(url);
            if (data) {
                this.SetEligibleClientManagers(data);
            }
            return data;
        }
        async SetEligibleClientManagers(data) {
            this.eligibleCSMs = data.eligibleCSMs ?? [];
            this.eligibleTSMs = data.eligibleTSMs ?? [];
        }
        async SaveTeamMember(teamMember) {
            var url = `${getTenantId()}/${this.apiNode}` + "/assign-team-member";
            let { data } = await service.post(url, teamMember);
            if (data) {
                return data;
            }
        }
        // Edit / delete member: the machine re-fetches the team afterwards (refreshingTeamInfo) so the list
        // keeps the server's ordering. Add inserts the row locally first, then re-fetches in the background.
        async EditTeamMember(teamMember) {
            var url = `${getTenantId()}/${this.apiNode}` + "/edit-team-member";
            let { data } = await service.post(url, teamMember);
            if (data) {
                return data;
            }
        }
        //Delete
        async DeleteTeamMemberById(teamMemberId) {
            var url = `${getTenantId()}/${this.apiNode}/` + teamMemberId + "/delete-team-member";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async AssignTeamLead(teamLead) {
            var url = `${getTenantId()}/${this.apiNode}` + "/assign-team-lead";
            let { data } = await service.post(url, teamLead);
            if (data) {
                this.SetTeamLead(teamLead.employeeId);
                return data;
            }
        }
        async SetTeamLead(employeeId) {
            var that = this;
            var target = that.team.teamMembers.findIndex((x) => x.employeeId == employeeId);
            var tar = that.team.teamMembers.findIndex((x) => x.isTeamLead == true);
            if (target !== -1) {
                that.team.teamMembers[target].isTeamLead = true;
            }
            if (tar !== -1) {
                that.team.teamMembers[tar].isTeamLead = false;
            }
            that.team.teamMembers = [...that.team.teamMembers];
        }
        async RemoveTeamLead(teamLead) {
            var url = `${getTenantId()}/${this.apiNode}` + "/remove-team-lead";
            let { data } = await service.post(url, teamLead);
            if (data) {
                this.RemoveTeamLeadFromTeam();
                return data;
            }
        }
        async RemoveTeamLeadFromTeam() {
            var that = this;
            var tar = that.team.teamMembers.findIndex((x) => x.isTeamLead == true);
            if (tar !== -1) {
                that.team.teamMembers[tar].isTeamLead = false;
            }
            that.team.teamMembers = [...that.team.teamMembers];
        }
        async CreateApexProject(payload) {
            var url = `${getTenantId()}/${this.apiNode}/add-apex-project?teamId=${payload.teamId}&teamLeadId=${payload.teamLeadId}`;
            let { data } = await service.post(url, payload.project);
            if (data) {
                this.AppendApexProject(plainToClass(PMOTeamApexProjectGridViewModel, data.apexProject));
            }
            return data;
        }
        async UpdateApexProject(project) {
            var url = `${getTenantId()}/${this.apiNode}/update-apex-project`;
            let { data } = await service.put(url, project);
            if (data) {
                this.AppendApexProject(plainToClass(PMOTeamApexProjectGridViewModel, data.apexProject));
                return data;
            }
        }
        async DeactivateTeam(deactivationReason) {
            var url = `${getTenantId()}/${this.apiNode}/deactivate-team`;
            let { data } = await service.post(url, deactivationReason);
            if (data) {
                return data;
            }
        }
        async ActivateTeam(teamId) {
            var url = `${getTenantId()}/${this.apiNode}/activate-team?teamId=${teamId}`;
            let { data } = await service.put(url);
            if (data) {
                return data;
            }
        }
        async DeactivateClient(deactivation) {
            var url = `${getTenantId()}/${this.apiNode}/deactivate-client`;
            let { data } = await service.post(url, deactivation);
            if (data) {
                return data;
            }
        }
        async AppendApexProject(apexProject) {
            var that = this;
            var target = that.team.apexProjects.findIndex((x) => x.projectId == apexProject.projectId);
            if (target !== -1) {
                that.team.apexProjects[target] = apexProject;
            }
            else {
                that.team.apexProjects.push(apexProject);
            }
            that.team.apexProjects = [...that.team.apexProjects];
        }
        async SwitchProjectOwnerToTeamLead(payload) {
            var url = `${getTenantId()}/${this.apiNode}/` + payload.projectId + "/" + payload.teamLeadId + "/switch";
            let { data } = await service.get(url);
            if (data) {
                this.AppendApexProject(plainToClass(PMOTeamApexProjectGridViewModel, data.apexProject));
            }
            return data;
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IClientSearchDataListingDTO !== "undefined" && IClientSearchDataListingDTO) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], ClientModule.prototype, "GetClients", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof IClientSearchDataListingDTO !== "undefined" && IClientSearchDataListingDTO) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], ClientModule.prototype, "GetClientHealth", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClients", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetCountryList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetStateLists", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], ClientModule.prototype, "GetCountryStateLists", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof IClientDTO !== "undefined" && IClientDTO) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ClientModule.prototype, "SaveClient", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof ClientModel !== "undefined" && ClientModel) === "function" ? _h : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientId", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof IClientDTO !== "undefined" && IClientDTO) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], ClientModule.prototype, "EditClient", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof Guid !== "undefined" && Guid) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], ClientModule.prototype, "DeleteClientById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], ClientModule.prototype, "GetClientDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], ClientModule.prototype, "GetClientContacts", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientContacts", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof IClientContactDTO !== "undefined" && IClientContactDTO) === "function" ? _q : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "AddClientContactToList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof ClientDetailedViewModel !== "undefined" && ClientDetailedViewModel) === "function" ? _r : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetIncludeInactiveContacts", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof IClientContactDTO !== "undefined" && IClientContactDTO) === "function" ? _s : Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], ClientModule.prototype, "SaveClientContact", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof IClientContactDTO !== "undefined" && IClientContactDTO) === "function" ? _u : Object]),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], ClientModule.prototype, "EditClientContact", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_w = typeof Guid !== "undefined" && Guid) === "function" ? _w : Object]),
        __metadata("design:returntype", typeof (_x = typeof Promise !== "undefined" && Promise) === "function" ? _x : Object)
    ], ClientModule.prototype, "DeleteClientContactById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_y = typeof IClientKeyContactDTO !== "undefined" && IClientKeyContactDTO) === "function" ? _y : Object]),
        __metadata("design:returntype", typeof (_z = typeof Promise !== "undefined" && Promise) === "function" ? _z : Object)
    ], ClientModule.prototype, "SetKeyContact", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_0 = typeof IClientKeyContactDTO !== "undefined" && IClientKeyContactDTO) === "function" ? _0 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetKeyContactOnClient", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_1 = typeof Promise !== "undefined" && Promise) === "function" ? _1 : Object)
    ], ClientModule.prototype, "UploadClientPicture", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetMediaFileId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetMediaUrl", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "ClearMediaFileData", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_2 = typeof Promise !== "undefined" && Promise) === "function" ? _2 : Object)
    ], ClientModule.prototype, "GetTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetTeams", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
    ], ClientModule.prototype, "GetRiskLevels", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetRiskLevels", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_4 = typeof Promise !== "undefined" && Promise) === "function" ? _4 : Object)
    ], ClientModule.prototype, "GetClientRisks", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientRisks", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_5 = typeof IClientRiskDTO !== "undefined" && IClientRiskDTO) === "function" ? _5 : Object]),
        __metadata("design:returntype", typeof (_6 = typeof Promise !== "undefined" && Promise) === "function" ? _6 : Object)
    ], ClientModule.prototype, "AddClientRisk", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_7 = typeof IClientRiskDTO !== "undefined" && IClientRiskDTO) === "function" ? _7 : Object]),
        __metadata("design:returntype", typeof (_8 = typeof Promise !== "undefined" && Promise) === "function" ? _8 : Object)
    ], ClientModule.prototype, "EditClientRisk", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_9 = typeof Guid !== "undefined" && Guid) === "function" ? _9 : Object]),
        __metadata("design:returntype", typeof (_10 = typeof Promise !== "undefined" && Promise) === "function" ? _10 : Object)
    ], ClientModule.prototype, "DeleteClientRiskById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_11 = typeof Promise !== "undefined" && Promise) === "function" ? _11 : Object)
    ], ClientModule.prototype, "GetClientOpportunities", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientOpportunities", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_12 = typeof IClientOpportunityDTO !== "undefined" && IClientOpportunityDTO) === "function" ? _12 : Object]),
        __metadata("design:returntype", typeof (_13 = typeof Promise !== "undefined" && Promise) === "function" ? _13 : Object)
    ], ClientModule.prototype, "AddClientOpportunity", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_14 = typeof IClientOpportunityDTO !== "undefined" && IClientOpportunityDTO) === "function" ? _14 : Object]),
        __metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
    ], ClientModule.prototype, "EditClientOpportunity", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_16 = typeof Guid !== "undefined" && Guid) === "function" ? _16 : Object]),
        __metadata("design:returntype", typeof (_17 = typeof Promise !== "undefined" && Promise) === "function" ? _17 : Object)
    ], ClientModule.prototype, "DeleteClientOpportunityById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_18 = typeof Promise !== "undefined" && Promise) === "function" ? _18 : Object)
    ], ClientModule.prototype, "GetClientAssignedEmployees", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetClientAssignedEmployees", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_19 = typeof Promise !== "undefined" && Promise) === "function" ? _19 : Object)
    ], ClientModule.prototype, "SaveTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_20 = typeof PMOTeam !== "undefined" && PMOTeam) === "function" ? _20 : Object]),
        __metadata("design:returntype", typeof (_21 = typeof Promise !== "undefined" && Promise) === "function" ? _21 : Object)
    ], ClientModule.prototype, "EditTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_22 = typeof Guid !== "undefined" && Guid) === "function" ? _22 : Object]),
        __metadata("design:returntype", typeof (_23 = typeof Promise !== "undefined" && Promise) === "function" ? _23 : Object)
    ], ClientModule.prototype, "DeleteTeamById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_24 = typeof Promise !== "undefined" && Promise) === "function" ? _24 : Object)
    ], ClientModule.prototype, "GetTeamDetailById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_25 = typeof IPMOTeamDetailedViewDTO !== "undefined" && IPMOTeamDetailedViewDTO) === "function" ? _25 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetTeamDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_26 = typeof Promise !== "undefined" && Promise) === "function" ? _26 : Object)
    ], ClientModule.prototype, "GetTeamOperations", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_27 = typeof Promise !== "undefined" && Promise) === "function" ? _27 : Object)
    ], ClientModule.prototype, "GetTeamOperationFieldHistory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_28 = typeof Promise !== "undefined" && Promise) === "function" ? _28 : Object)
    ], ClientModule.prototype, "SaveTeamOperations", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_29 = typeof ITeamOperationsResponse !== "undefined" && ITeamOperationsResponse) === "function" ? _29 : Object]),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "SetTeamOperations", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "SetTeamOperationHistory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "ResetTeamOperations", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_30 = typeof Promise !== "undefined" && Promise) === "function" ? _30 : Object)
    ], ClientModule.prototype, "GetTeamCorrespondence", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_31 = typeof ITeamCorrespondenceSaveDTO !== "undefined" && ITeamCorrespondenceSaveDTO) === "function" ? _31 : Object]),
        __metadata("design:returntype", typeof (_32 = typeof Promise !== "undefined" && Promise) === "function" ? _32 : Object)
    ], ClientModule.prototype, "SaveTeamCorrespondence", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_33 = typeof ITeamCorrespondenceResponse !== "undefined" && ITeamCorrespondenceResponse) === "function" ? _33 : Object]),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "SetTeamCorrespondence", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_34 = typeof IPMOTeamMemberDTO !== "undefined" && IPMOTeamMemberDTO) === "function" ? _34 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "AddTeamMemberToList", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_35 = typeof Promise !== "undefined" && Promise) === "function" ? _35 : Object)
    ], ClientModule.prototype, "GetEligableUserForTeam", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetEligableUserForTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_36 = typeof Promise !== "undefined" && Promise) === "function" ? _36 : Object)
    ], ClientModule.prototype, "GetEligibleClientManagers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_37 = typeof IEligibleClientManagerResponse !== "undefined" && IEligibleClientManagerResponse) === "function" ? _37 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetEligibleClientManagers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_38 = typeof PMOTeamMember !== "undefined" && PMOTeamMember) === "function" ? _38 : Object]),
        __metadata("design:returntype", typeof (_39 = typeof Promise !== "undefined" && Promise) === "function" ? _39 : Object)
    ], ClientModule.prototype, "SaveTeamMember", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_40 = typeof PMOTeamMember !== "undefined" && PMOTeamMember) === "function" ? _40 : Object]),
        __metadata("design:returntype", typeof (_41 = typeof Promise !== "undefined" && Promise) === "function" ? _41 : Object)
    ], ClientModule.prototype, "EditTeamMember", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_42 = typeof Promise !== "undefined" && Promise) === "function" ? _42 : Object)
    ], ClientModule.prototype, "DeleteTeamMemberById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_43 = typeof PMOTeamLead !== "undefined" && PMOTeamLead) === "function" ? _43 : Object]),
        __metadata("design:returntype", typeof (_44 = typeof Promise !== "undefined" && Promise) === "function" ? _44 : Object)
    ], ClientModule.prototype, "AssignTeamLead", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "SetTeamLead", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_45 = typeof PMOTeamLead !== "undefined" && PMOTeamLead) === "function" ? _45 : Object]),
        __metadata("design:returntype", typeof (_46 = typeof Promise !== "undefined" && Promise) === "function" ? _46 : Object)
    ], ClientModule.prototype, "RemoveTeamLead", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "RemoveTeamLeadFromTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_47 = typeof Promise !== "undefined" && Promise) === "function" ? _47 : Object)
    ], ClientModule.prototype, "CreateApexProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_48 = typeof IPMOProjectDTO !== "undefined" && IPMOProjectDTO) === "function" ? _48 : Object]),
        __metadata("design:returntype", typeof (_49 = typeof Promise !== "undefined" && Promise) === "function" ? _49 : Object)
    ], ClientModule.prototype, "UpdateApexProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_50 = typeof ClientTeamDeactivationReasonModel !== "undefined" && ClientTeamDeactivationReasonModel) === "function" ? _50 : Object]),
        __metadata("design:returntype", typeof (_51 = typeof Promise !== "undefined" && Promise) === "function" ? _51 : Object)
    ], ClientModule.prototype, "DeactivateTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_52 = typeof Promise !== "undefined" && Promise) === "function" ? _52 : Object)
    ], ClientModule.prototype, "ActivateTeam", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_53 = typeof ClientDeactivationReasonModel !== "undefined" && ClientDeactivationReasonModel) === "function" ? _53 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "DeactivateClient", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_54 = typeof IPMOTeamApexProjectGridViewDTO !== "undefined" && IPMOTeamApexProjectGridViewDTO) === "function" ? _54 : Object]),
        __metadata("design:returntype", Promise)
    ], ClientModule.prototype, "AppendApexProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_55 = typeof Promise !== "undefined" && Promise) === "function" ? _55 : Object)
    ], ClientModule.prototype, "SwitchProjectOwnerToTeamLead", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_56 = typeof ClientSearchDataModel !== "undefined" && ClientSearchDataModel) === "function" ? _56 : Object]),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ClientModule.prototype, "ClearSearchParams", null);
    ClientModule = __decorate([
        Module({ dynamic: true, store: store, name: "clients", namespaced: true })
    ], ClientModule);
    return ClientModule;
})();
export default getModule(ClientModule);
